import React, { useState, useEffect } from 'react';
import './Area.css';
import { Trash2, SquarePen, Eye, Plus, EllipsisVertical } from 'lucide-react';
import AreaForm from './AreaForm.js';
import { useStateManager } from 'react-select';
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Checkbox,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Button,
    ModalCloseButton,
    Spinner
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { pageData } from '../../utils/paginationConfig';
import ProgressBar from '../../utils/progressBar/ProgressBar';
import { toast } from 'react-toastify';
import Pagination from '../../utils/pagination/Pagination';
import { getAreas } from '../../redux/reduxApi/areaReduxApi.js';
import { deleteAreaAction } from '../../redux/reduxSlice/AreaSlice.js';
import { deleteArea } from '../../redux/api/areaApi/AreaApi.js';
import { countArea } from '../../redux/api/areaApi/AreaApi.js';

function AreaList() {
    const dispatch = useDispatch();
    const [totalCount, setTotalCount] = useState(0);
    const [deleteAreaROWID, setDeleteAreaROWID] = useState("");
    const [showProgressBar, setShowProgressBar] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [areaROWID, setAreaROWID] = useState("");
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(5);
    const getAreaData = useSelector((state) => state.area.area)
    const [areaData, setAreaData] = useState([]);
    const [data, setData] = useState([]);
    const [areaOpen, setAreaOpen] = useState(false);
    const [view, setView] = useState('List');
    const [isOpen, setIsOpen] = useState(false);
    const [dataToEdit, setDataToEdit] = useState({});
    const [isUpdateMode, setIsUpdateMode] = useState(false);

    // total locations count
    const fetchTotalCount = async () => {
        try {
            const response = await countArea();
            console.log("API Response:", response.data);
            const count = parseInt(response.data.count, 10);
            setTotalCount(count);
        } catch (error) {
            console.error("Error fetching total locations count:", error);
        }
    };
    useEffect(() => {
        fetchTotalCount();
    }, []);

    // console data to be displayed
    useEffect(() => {
        setAreaData(getAreaData)
    }, [getAreaData])

    // Get locations -->
    useEffect(() => {
        const page = 1;
        setLoading(true);
        dispatch(getAreas(page)).then((response) => {
        }).catch((error) => {
            console.log(error)
        }).finally(() => {
            setLoading(false);
            setTimeout(() => {
            }, [300])
        })
    }, [])

    useEffect(() => {
        console.log({ areaData })
        if (areaData && areaData.length > 0) {
            setData(areaData)
        }
    }, [areaData])

    useEffect(() => {
        if (currentPage % pageData.apiHit === 0) {
            const page = (currentPage / pageData.apiHit) + 1;
            dispatch(getAreas(page))
        }
    }, [totalPages])

    // for Trash modal
    const openTrash = () => {
        setIsOpen(true)
    }
    const closeTrash = () => {
        setIsOpen(false)
    }

    const openAreaDrawer = () => {
        setAreaOpen(true);
    };

    const closeAreaDrawer = () => {
        setAreaOpen(false);
    };

    // Single Select
    const handleRowSelect = (ROWID) => {
        const isSelected = selectedRows.includes(ROWID);
        let newSelectedRows = [];

        if (!isSelected) {
            newSelectedRows = [...selectedRows, ROWID];
        } else {
            newSelectedRows = selectedRows.filter(rowAreaId => rowAreaId !== ROWID);
        }
        setSelectedRows(newSelectedRows);
        setAreaROWID(newSelectedRows.join(','));
        console.log(ROWID)
    };
    // All Select
    const handleSelectAllRows = () => {
        const allSelected = selectedRows.length === data.length;
        let newSelectedRows = [];
        if (!allSelected) {
            newSelectedRows = data.map(item => item.areas?.ROWID);
        }
        setSelectedRows(newSelectedRows);
        console.log(newSelectedRows)
    };
    // Handle Delete Function
    const handleDelete = () => {
        setShowProgressBar(true);
        setLoading(true);
        const idsToDelete = selectedRows.length === 0 ? [deleteAreaROWID] : selectedRows;
        Promise.all(idsToDelete.map(id => deleteArea(id)))
            .then(() => {
                setData(prevData => prevData.filter(item => !idsToDelete.includes(item.areas.ROWID)));
                dispatch(deleteAreaAction(idsToDelete));
                toast.success("Row Deleted successfully");
                fetchTotalCount();
            })
            .catch((error) => {
                console.log(error);
                toast.error("Row not deleted");
            })
            .finally(() => {
                setShowProgressBar(false);
                setLoading(false);
                closeTrash();
                setSelectedRows([]);
                setAreaROWID("");
            });
    };
    // handle update
    const handleUpdate = (id) => {
        setAreaROWID(id)
        setIsUpdateMode(!isUpdateMode)
    }

    // Function to parse tasks in a more readable format
    const parseTasks = (tasks) => {
        try {
            const taskList = JSON.parse(tasks);
            if (Array.isArray(taskList)) {
                return taskList.map((task, idx) => <div key={idx} className="task-item">{task.Task}</div>);
            }
        } catch (error) {
            console.error("Error parsing tasks:", error);
        }
        return null;
    };
    return (
        <>
            {loading && (
                <div className="spinner-overlay">
                    <Spinner size="xl" color="pink.500" />
                </div>
            )}
            {showProgressBar && <ProgressBar colorScheme="pink" />}
            <Modal isOpen={isOpen} onClose={closeTrash}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Are you sure you want to Delete?</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                    </ModalBody>
                    <ModalFooter>
                        <Button className='create-button' mr={3} onClick={handleDelete}>
                            Delete
                        </Button>
                        <Button className='cancel-button' onClick={closeTrash}>Cancel</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <AreaForm areaOpen={areaOpen} closeAreaDrawer={closeAreaDrawer} isUpdateMode={isUpdateMode} areaROWID={areaROWID} setIsUpdateMode={setIsUpdateMode} dataToEdit={dataToEdit} />
            {view === 'List' ? (
                <div >
                    <div className='pt-2 d-flex justify-content-end align-items-center gap-2 px-3'>
                        <div className="d-flex justify-content-end">
                            {selectedRows.length === 0 && (
                                <>
                                    <button className="new-button mx-2" onClick={openAreaDrawer}>
                                        <Plus size="18px" />
                                        <span className="ms-1">New</span>
                                    </button>
                                </>
                            )}
                        </div>
                        {selectedRows.length > 0 && (
                            <div className="align-items-left mt-2 d-flex gap-2">
                                <button className="new-button" onClick={openTrash}>Delete All</button>
                            </div>
                        )}                        <div className="dropdown">
                            <button className="mb-0 cancel-button dropdown-toggle px-0 " type="button" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                < EllipsisVertical />
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenu2">
                                <li onClick={() => { setView('List') }}><button className="dropdown-item" type="button">
                                    <label htmlFor='test-table-xls-button' className=''>
                                        <span className='ms-1'>List</span>
                                    </label>
                                </button></li>
                                <li onClick={() => { setView('Card') }}><button className="dropdown-item" type="button">
                                    <label htmlFor='test-table-xls-button' className=''>
                                        <span className='ms-1'>Tiles</span>
                                    </label>
                                </button></li>
                            </ul>
                        </div>
                    </div>
                    <div className='custom-scroll' style={{ minHeight: "70vh" }}>
                        <TableContainer className='card card-detail'>
                            <Table id="table-to-xls" variant='simple' size='sm' >
                                <Thead>
                                    <Tr className='tr-border'>
                                        <Th className='py-1 th-color'>
                                            <Checkbox isChecked={selectedRows?.length === data?.length} onChange={handleSelectAllRows} />
                                        </Th>
                                        <Th className='py-1 th-color'>Actions</Th>
                                        <Th className='py-1 th-color'>Area</Th>
                                        <Th className='py-1 th-color'>Task</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {data.map((item, idx) => (
                                        <Tr key={idx} className='tr-border'>
                                            <Td>
                                                <Checkbox isChecked={selectedRows.includes(item?.areas?.ROWID)} onChange={() => handleRowSelect(item?.areas?.ROWID)} />
                                            </Td>
                                            <Td>
                                                <div className="d-flex gap-1">
                                                    <i onClick={() => { openAreaDrawer(item.areas); setDataToEdit(item); setIsUpdateMode(true) }} style={{ cursor: 'pointer' }} >
                                                        <SquarePen color="#ff176b" size="16px" strokeWidth="1" />
                                                    </i>
                                                    <i style={{ cursor: 'pointer' }}>
                                                        <Trash2 color="#ff176b" size="16px" strokeWidth="1" onClick={(e) => { openTrash(e); setDeleteAreaROWID(item?.areas?.ROWID) }} />
                                                    </i>
                                                </div>
                                            </Td>
                                            <Td>{item?.areas?.areaName}</Td>
                                            <Td>{JSON.parse(item?.areas?.tasks).map((item) => (item.Task)).join(' || ')}</Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </div>
                    <div className="footer d-flex fixed-bottom start-20" >
                        <div className="total" style={{ marginLeft: '20%', marginTop: '15px' }}>
                            <p class="fw-semibold">Total Count: {totalCount} </p>
                        </div>
                        {/* Pagination */}
                        <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto" >
                            <Pagination totalPages={totalPages} onPageChange={setCurrentPage} />
                        </div>
                        {/* End Pagination */}
                    </div>
                </div>)
                : (
                    <div className='mb-5'>
                        <div className='pt-2 d-flex justify-content-between align-items-center px-3' style={{ backgroundColor: 'rgba(196,196,196,0.2)' }}>
                            <h5 className='mb-0 text-muted mx-2 py-2'>Areas</h5>
                            <div className='d-flex justify-content-end gap-2'>
                                <button onClick={openAreaDrawer} className='create-button'><Plus size="18" />New</button>
                                <div className="dropdown">
                                    <button className="mb-0 cancel-button dropdown-toggle px-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <EllipsisVertical />
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenu2">
                                        <li onClick={() => { setView('List') }}>
                                            <button className="dropdown-item" type="button">
                                                <span className='ms-1'>List</span>
                                            </button>
                                        </li>
                                        <li onClick={() => { setView('Card') }}>
                                            <button className="dropdown-item" type="button">
                                                <span className='ms-1'>Tiles</span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style={{ overflowY: "auto", maxHeight: '80vh', backgroundColor: 'rgba(196,196,196,0.2)' }}>
                            <div className='area-card-div'>
                                <div className='row mt-2'>
                                    {data.map((item, idx) => (
                                        <div key={idx} className='col-3 mb-4'>
                                            <div className="cookie-card position-relative">
                                                <span className="title">
                                                    {item?.areas?.areaName.length > 15 ? item?.areas?.areaName.slice(0, 20) + "..." : item?.areas?.areaName}
                                                </span>
                                                <p className="description">{item?.areas?.areaName}</p>
                                                <div className="actions d-flex justify-content-center">
                                                    <div className='d-flex gap-1 justify-content-end'>
                                                        <Link to="/area-detail-view">
                                                            <Eye size="18" color='#ff176b' />
                                                        </Link>
                                                        <SquarePen size="18" color='#ff176b' onClick={openAreaDrawer} />
                                                        <Trash2 size="18" color='#ff176b' onClick={openTrash} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        </>
    )
}

export default AreaList
